export default {"src":"/_next/static/media/3.7159c71a.svg","height":170,"width":304,"blurWidth":0,"blurHeight":0};